import React, {useEffect, useState} from 'react';
import {Button, Input, Popconfirm, Table, message} from 'antd';
import {DeleteOutlined, PlusOutlined} from '@ant-design/icons';
import userService from '../../../services/user.service';
import './BlockedTempMail.css';

const normalizeDomain = value => {
  let domain = String (value || '').trim ().toLowerCase ();
  domain = domain.replace (/^https?:\/\//, '');
  domain = domain.replace (/^www\./, '');
  domain = domain.replace (/^@/, '');
  domain = domain.split ('/')[0];
  domain = domain.split (':')[0];
  return domain;
};

const BlockedTempMail = () => {
  const [domains, setDomains] = useState ([]);
  const [domain, setDomain] = useState ('');
  const [loading, setLoading] = useState (false);
  const [saving, setSaving] = useState (false);

  const getDomains = async () => {
    setLoading (true);
    try {
      const response = await userService.getBlockedTempMailDomains ();
      setDomains (response.data || []);
    } catch (err) {
      message.error (
        err.response?.data?.message ||
          err.message ||
          'Unable to load blocked domains.'
      );
    } finally {
      setLoading (false);
    }
  };

  useEffect (() => {
    getDomains ();
  }, []);

  const addDomain = async () => {
    const normalizedDomain = normalizeDomain (domain);

    if (!normalizedDomain) {
      message.error ('Please enter a domain.');
      return;
    }

    setSaving (true);
    try {
      await userService.addBlockedTempMailDomain (normalizedDomain);
      setDomain ('');
      message.success ('Domain blocked successfully.');
      getDomains ();
    } catch (err) {
      message.error (
        err.response?.data?.message ||
          err.message ||
          'Unable to block this domain.'
      );
    } finally {
      setSaving (false);
    }
  };

  const deleteDomain = async id => {
    try {
      await userService.deleteBlockedTempMailDomain (id);
      message.success ('Domain removed.');
      getDomains ();
    } catch (err) {
      message.error (
        err.response?.data?.message ||
          err.message ||
          'Unable to remove this domain.'
      );
    }
  };

  const columns = [
    {
      title: 'Domain',
      dataIndex: 'domain',
      key: 'domain',
    },
    {
      title: 'Added On',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: value => (value ? new Date (value).toLocaleString () : 'N/A'),
    },
    {
      title: 'Action',
      key: 'action',
      width: 120,
      render: (_, record) => (
        <Popconfirm
          title="Remove this blocked domain?"
          okText="Remove"
          cancelText="Cancel"
          onConfirm={() => deleteDomain (record._id)}
        >
          <Button danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div className="blocked-temp-mail-page">
      <div className="blocked-temp-mail-header">
        <h2>Block Temp Mail</h2>
      </div>

      <div className="blocked-temp-mail-controls">
        <Input
          value={domain}
          onChange={event => setDomain (event.target.value)}
          onPressEnter={addDomain}
          placeholder="testmail.com"
        />
        <Button
          type="primary"
          icon={<PlusOutlined />}
          loading={saving}
          onClick={addDomain}
        >
          Block Domain
        </Button>
      </div>

      <Table
        rowKey="_id"
        columns={columns}
        dataSource={domains}
        loading={loading}
        pagination={{pageSize: 10}}
      />
    </div>
  );
};

export default BlockedTempMail;
